// extracted by mini-css-extract-plugin
module.exports = {"ChromaMessagesContainer":"ChromaMessages_ChromaMessagesContainer__3x42V","ChromaMessages":"ChromaMessages_ChromaMessages__XN1sW","Message":"ChromaMessages_Message__3lJQt"};